import Vue from 'vue';
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib'
import VuetifyToastAlert from './toast-alert'
import doeColors from '../settings/doe-colors'

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon
  }
});

Vue.use(VuetifyToastAlert, {
  x: 'left',
  y: 'bottom',
  icon: 'error',
  timeout: 0,
  dismissable: false,
  multiLine: true,
  queueable: false,
  showClose: true,
  closeIcon: 'close',
});

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: doeColors.primary.navy,
        secondary: doeColors.primary.lightblue,
        accent: doeColors.secondary.blue1,
        success: doeColors.secondary.blue2,
      }
    }
  },
});
